import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * `false` on the server and during the hydration render of the component,
 * `true` afterwards. Unlike a mounted flag set in an effect, this also holds
 * inside Suspense boundaries that hydrate late (lazy chunks), where hooks run
 * for the first time long after the rest of the page is interactive.
 */
export const useIsHydrated = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
